/**
 * Alpine.js component for the navbar product search autocomplete.
 *
 * Replaces the legacy jQuery + typeahead.js + Bloodhound stack. Mounted via
 * x-data="navbarSearch" on the search input's wrapping element.
 */
export function navbarSearch(suggestionsUrl, searchUrl) {
    return {
        query: '',
        suggestions: [],
        showDropdown: false,
        debounceTimer: null,
        suggestionsUrl,
        searchUrl,

        onInput() {
            const q = this.query.trim();
            clearTimeout(this.debounceTimer);

            if (q.length < 1) {
                this.suggestions = [];
                this.showDropdown = false;
                return;
            }

            this.debounceTimer = setTimeout(() => this.fetchSuggestions(q), 250);
        },

        async fetchSuggestions(q) {
            try {
                const res = await window.axios.get(this.suggestionsUrl, {
                    params: { search: q },
                });
                const items = (res.data && res.data.result) || [];
                this.suggestions = items.slice(0, 10).map((p) => ({
                    id: p.id,
                    name: p.name,
                }));
                this.showDropdown = this.suggestions.length > 0;
            } catch (error) {
                // Endpoint may legitimately return 500 in dev; fail silently
                // so the input still works for the Enter-to-search path.
                this.suggestions = [];
                this.showDropdown = false;
            }
        },

        select(item) {
            window.location.href = `/product/${item.id}/${encodeURIComponent(item.name)}`;
        },

        submitSearch(event) {
            if (event.key === 'Enter' || event.keyCode === 13) {
                event.preventDefault();
                const q = this.query.trim();
                if (q.length === 0) return;
                window.location.href = `${this.searchUrl}?search=${encodeURIComponent(q)}`;
            }
        },

        closeDropdown() {
            // setTimeout so click on a suggestion fires before blur hides it.
            setTimeout(() => { this.showDropdown = false; }, 150);
        },
    };
}
